import { render, staticRenderFns } from "./EditProfileModal.vue?vue&type=template&id=6290d33a"
import script from "./EditProfileModal.vue?vue&type=script&lang=js"
export * from "./EditProfileModal.vue?vue&type=script&lang=js"
import style0 from "./EditProfileModal.vue?vue&type=style&index=0&id=6290d33a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports